import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { FaBars, FaTimes, FaArrowRight } from 'react-icons/fa';
import Insights from './Insights';
import Article from './Article';
import Services from './Services';
import Team from './Team';
import Contact from './Contact';

// --- Navbar Component ---
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar container">
      <Link to="/" style={{textDecoration: 'none'}} onClick={closeMenu}>
        <span className="logo-text">Exia Group</span>
      </Link>
      
      <ul className={menuOpen ? "nav-menu active" : "nav-menu"}>
        <li><Link to="/insights" className="nav-link" onClick={closeMenu}>Insights</Link></li>
        <li><Link to="/services" className="nav-link" onClick={closeMenu}>Services</Link></li>
        <li><Link to="/team" className="nav-link" onClick={closeMenu}>Our Team</Link></li>
        
        <li>
          <Link to="/contact" style={{textDecoration: 'none'}} onClick={closeMenu}>
             <span className="nav-btn">Contact Us</span>
          </Link>
        </li>
      </ul>

      <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer className="footer-section">
    <div className="container">
      <h2 className="logo-text" style={{fontSize:'1.5rem', marginBottom:'20px'}}>Exia Group.</h2>
      <p style={{color:'#666'}}>© 2025 Exia Group. All rights reserved.</p>
    </div>
  </footer>
);

// --- Home Page ---
const Home = () => (
  <div className="page-fade-in">
    <div className="container">
      <header className="hero">
        <div className="hero-content">
          <h1>Let there be <br /><span className="hero-accent">Change.</span></h1>
          <p className="hero-subtext">
            We provide support to local businesses of South Jersey and the US government to navigate the eternal cycle of reinvention.
          </p>
          <Link to="/services" style={{textDecoration:'none'}}>
            <span className="btn btn-primary">What We Do</span>
          </Link>
        </div>
        <div className="hero-img-container">
          <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80" alt="Office" className="hero-img" />
        </div>
      </header>
    </div>

    <section className="services container">
      <span className="section-label">Our Capabilities</span>
      <h2 className="section-title">Total Enterprise Reinvention</h2>
      <div className="grid-3">
  
      {/* Card 1: AI & Data */}
      <Link to="/services" className="card">
        <div className="card-content">
          <h3>AI & Data</h3>
          <p>Unlock the value of data and AI to build a resilient digital core.</p>
          <FaArrowRight className="card-arrow" />
        </div>
        <div 
          className="card-image" 
          style={{ backgroundImage: "url(/images/ai-data.jpg)" }}
        ></div>
      </Link>
      
      {/* Card 2: Cloud */}
      <Link to="/services" className="card">
        <div className="card-content">
          <h3>Cloud</h3>
          <p>Accelerate your move to the cloud to increase agility.</p>
          <FaArrowRight className="card-arrow" />
        </div>
        <div 
          className="card-image" 
          style={{ backgroundImage: "url(/images/cloud.jpg)" }}
        ></div>
      </Link>
      
      {/* Card 3: Consulting */}
      <Link to="/services" className="card">
        <div className="card-content">
          <h3>Consulting</h3>
          <p>Deep industry expertise to execute your strategy.</p>
          <FaArrowRight className="card-arrow" />
        </div>
        <div 
          className="card-image" 
          style={{ backgroundImage: "url(/images/consulting.jpg)" }}
        ></div>
      </Link>

    </div>
    </section>
  </div>
);

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/services" element={<Services />} />
          <Route path="/team" element={<Team />} />
          <Route path="/article" element={<Article />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;